import { useState, useEffect, useCallback } from 'react';

function useApi(apiFn, deps = []) {
  const [state, setState] = useState({ data: null, meta: null, loading: true, error: null });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const fetch = useCallback(async () => {
    setState(prev => ({ ...prev, loading: true, error: null }));
    try {
      const result = await apiFn();
      setState({ data: result.data, meta: result.meta || null, loading: false, error: null });
    } catch (err) {
      setState({ data: null, loading: false, error: err.message || 'Error al cargar datos' });
    }
  }, deps);

  useEffect(() => { fetch(); }, [fetch]);

  return { ...state, refetch: fetch };
}

export default useApi;
